import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { Router } from '@angular/router'
import { AccountsService } from '@appShared/services'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'
import { environment } from '@appEnvironments/environment'

@Component({
   selector: 'app-site-sidebar',
   templateUrl: './site-sidebar.component.html',
   styleUrls: ['./site-sidebar.component.less'],
   changeDetection: ChangeDetectionStrategy.OnPush,
   standalone: true
})
export class SiteSidebarComponent {
   private readonly _router = inject(Router)
   private readonly _accountService = inject(AccountsService)

   routes = SITE_DIRECTORY_ROUTES
   internalUris = environment.internalUris

   goToSearch(): void {
      // If the previous search produced a single result, clear it so the
      // search page doesn't immediately auto-navigate to the detail page.
      if (this._accountService.accountSearchResults.value().length === 1) {
         this._accountService.clearSearch()
      }

      this._router.navigateByUrl(`/${this.routes.customerService.uri}`)
   }
}
